import ArrowIcon from "@icons/arrowIcon.svg";
import LearningPathItemVideos from "@icons/learningPathItemVideos.svg";
import LearningPathItemSubjects from "@icons/learningPathItemSubjects.svg";
import styles from "./learningSimilarCourse.module.scss";
import classNames from "classnames";

export const LearningSimilarCourse = (props: Props) => {
  const LinkComponent = props.linkAs ?? "a";

  const renderIconContainer = (icon: any, label: string) => (
    <div className={styles["iconContainer"]}>
      {icon}
      <span>{label}</span>
    </div>
  );

  return (
    <div
      className={classNames(
        styles["container"],
        props.logo && styles["withLogo"],
      )}
    >
      {props.logo && (
        <div className={styles["logoContainer"]}>
          <img src={props.logo} alt={props.courseName} loading="lazy" />
        </div>
      )}
      <div className={styles["contentContainer"]}>
        <LinkComponent href={props.url} className={styles["courseName"]}>
          {props.courseName}
        </LinkComponent>
        {props.description && (
          <div className={styles["description"]}>{props.description}</div>
        )}

        <div className={styles["bottomContainer"]}>
          <div className={styles["iconsContainer"]}>
            {props.numberOfSubjectsLabel &&
              renderIconContainer(
                <LearningPathItemSubjects />,
                props.numberOfSubjectsLabel,
              )}
            {props.numberOfVideosLabel &&
              renderIconContainer(
                <LearningPathItemVideos />,
                props.numberOfVideosLabel,
              )}
          </div>
          <div className={styles["goPath"]}>
            {props.goPathLabel}
            <ArrowIcon />
          </div>
        </div>
      </div>
    </div>
  );
};

interface Props {
  logo?: string;
  courseName: string;
  description?: string;
  numberOfSubjectsLabel: string;
  numberOfVideosLabel: string;
  url: string;
  goPathLabel: string;
  linkAs?: React.ElementType;
}
